<div
  style="
    position: relative;
    padding: 5px;
    border: 1px solid white;
    border-radius: 20px;
  "
>
  <div
    [style.background]="linearGradient"
    style="
      background: white;
      border: 1px solid transparent;
      border-radius: 20px;
    "
  >
    @if (type) {
      <div
        style="
          padding-top: 1em;
          width: 50%;
          margin: 0 auto 0;
          display: flex;
          justify-content: center;
        "
      >
        <div style="display: flex; gap: 0.5em; align-items: center">
          <div [style.background]="lineColor" class="linea linea1"></div>
          <div [style.background]="lineColor" class="linea linea2"></div>
          <div [style.background]="lineColor" class="linea linea3"></div>
        </div>
        <div
          class="shadow"
          style="
            background: white;
            border-radius: 10px;
            margin: 0.5em;
            width: 60px;
            height: 60px;
            object-fit: cover;
            overflow: hidden;
            padding: 0.5em;
            box-sizing: border-box;
          "
        >
          <div [style.color]="lineColor">
            @switch (type) {
              @case ("1") {
                <div>
                  <mat-icon class="size-icon" svgIcon="exitomodal"></mat-icon>
                </div>
              }
              @case ("2") {
                <div>
                  <mat-icon
                    class="size-icon"
                    svgIcon="preguntamodal"
                  ></mat-icon>
                </div>
              }
              @case ("3") {
                <div>
                  <mat-icon class="size-icon" svgIcon="advertencia"></mat-icon>
                </div>
              }
              @case ("4") {
                <div>
                  <mat-icon class="size-icon" svgIcon="errormodal"></mat-icon>
                </div>
              }
              @default {
                <div>
                  <mat-icon class="size-icon" svgIcon="exitomodal"></mat-icon>
                </div>
              }
            }
          </div>
        </div>
        <div style="display: flex; gap: 0.5em; align-items: center">
          <div [style.background]="lineColor" class="linea linea3"></div>
          <div [style.background]="lineColor" class="linea linea2"></div>
          <div [style.background]="lineColor" class="linea linea1"></div>
        </div>
      </div>
    }
    <div style="max-height: 70vh; overflow: auto">
      @if (!!title) {
        <span class="principal-title">{{ title }}</span>
      }
      @defer (when !!content) {
        <ng-container *ngTemplateOutlet="content"></ng-container>
      }
      @if (!!message) {
        <span class="mesagge">{{ message }}</span>
      }
      @if (!!message2) {
        <span class="message-2">{{ message2 }}</span>
      }
      @if (footer) {
        <div class="btns-container">
          @if (btn2) {
            <button
              class="btn-02"
              [style.background]="linearGradientButton"
              matDialogClose
              (click)="second()"
            >
              {{ btn2 }}
            </button>
          }
          @if (btn) {
            <button dia class="btn-02 btn-exito" (click)="primary()">
              {{ btn }}
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
